import axios from 'axios'

const axiosUtility = axios.create({
  // baseURL: 'http://localhost:3000/dev/api',
  baseURL: process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : 'https://oysjx974ui.execute-api.us-east-2.amazonaws.com/dev/api',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
})

export default axiosUtility
